// plan-02 S04: light bloom pass — opt-in, samples high-luma regions
// Default off pending perf verification. Bible S13B: CSS halation does most of the work.

import type { DrawPass } from '../canvas'

export function createLightBloom(enabled: boolean): DrawPass {
  if (!enabled) return () => {}

  let frameCount = 0

  return (ctx, w, h, _t): void => {
    frameCount++
    if (frameCount % 4 !== 0) return

    // sample center region for high-luma, draw low-opacity blurred copy
    const cx = Math.floor(w * 0.15)
    const cy = Math.floor(h * 0.15)
    const cw = Math.floor(w * 0.7)
    const ch = Math.floor(h * 0.7)

    if (cw < 1 || ch < 1) return

    ctx.save()
    ctx.globalAlpha = 0.02
    ctx.filter = 'blur(6px)'
    ctx.globalCompositeOperation = 'lighter'
    ctx.drawImage(ctx.canvas, cx, cy, cw, ch, cx, cy, cw, ch)
    ctx.restore()
  }
}
